<div class="clausulas-modal">
  <button class="btn close-modal" (click)="activeModal.dismiss()">
    <i class="fas fa-times"></i>
  </button>
  <div class="d-flex justify-content-center">
    <h4>{{title}}</h4>
  </div>
  <div class="row">
    <div class="col-6">
      <div class="select-text">
        Materia
      </div>
      <select [(ngModel)]="selectedMateria" (ngModelChange)="getSubmaterias($event)">
        @for (materia of materias; track materia) {
          <option [ngValue]="materia">{{materia.name}}</option>
        }
      </select>
    </div>
    <div class="col-6">
      <div class="select-text">
        Submateria
      </div>
      <select [(ngModel)]="selectedSubmateria">
        <option [ngValue]="undefined"></option>
        @for (submateria of submaterias; track submateria) {
          <option [ngValue]="submateria">{{submateria.name}}</option>
        }
      </select>
    </div>
  </div>
  <div class="d-flex justify-content-center">
    @if (emptyButton && statusModal === false) {
      <button class="mx-2 round-button-green" (click)="activeModal.close({subject: undefined, parent: undefined})">
        {{emptyButton}}
      </button>
    }
    @if (statusModal === false) {
      <button class="mx-2 round-button" (click)="activeModal.close({subject: selectedSubmateria, parent: selectedMateria})">
        Aceptar
      </button>
    }
    @if (statusModal && emptyButton) {
      <button class="mx-2 round-button-green" (click)="confirm(true)">
        {{emptyButton}}
      </button>
    }
    @if (statusModal) {
      <button class="mx-2 round-button" (click)="confirm(false)">
        Aceptar
      </button>
    }

  </div>
</div>
